export default {
  wrapper: {
    fontSize: 13,
  },
}
